import { clsx } from "clsx";
import { forwardRef } from "react";

import style from "./Addon.module.css";

interface AddonProps {
  label: string;
  placement?: "prefix" | "suffix";
}
export const Addon = forwardRef<HTMLDivElement, AddonProps>(function Addon(props) {
  return (
    <div
      className={clsx(style.addon, {
        [style.prefix]: props.placement === "prefix",
        [style.suffix]: props.placement === "suffix",
      })}
    >
      {props.label}
    </div>
  );
});
